import { IParcel, IShipment, NotEbayItemParcel } from '@types';

/**
 * single-flow only maps a parcel if it is the first in the list of parcels and a custom parcel.
 * If you have predefined parcels in bulk and autocomplete automatically fills the parcel with one of them, single flow
 * ignores it because the id is not 'custom-parcel-id'
 */
const packageDetailsImportedFromEbay = (_package: IParcel): boolean => _package.id === 'custom-parcel-id';

export const getEbayItemPackageDimensions = (shipment: IShipment): IParcel => {
    const packages = shipment.packages || [];
    const mainPackage = packages[0] || NotEbayItemParcel;
    if (!packageDetailsImportedFromEbay(mainPackage)) {
        return NotEbayItemParcel;
    }

    return {
        height: mainPackage.height,
        length: mainPackage.length,
        weight: mainPackage.weight,
        width: mainPackage.width,
    };
};
